import { Apartment } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React from 'react';
import { IParteBasica } from '../../modelo/Partes';
import TableRepresentante from './TableRepresentante';
import './css/processo.css';
import ProcessoStore from '@/store/ProcessoStore';


interface IPropsTableParte {
    parte: IParteBasica
}

class TableParte extends React.Component<IPropsTableParte> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="lista">
                    <div className="titulo">
                        {this.props.parte.tipo}
                    </div>
                    <div className="lista-align-left">
                        {`${this.props.parte.nomeSocial || this.props.parte.nome} 
                          ${this.props.parte.procuradoria?.nome ? `(${this.props.parte.procuradoria.nome})` : ''}
                          ${this.props.parte.registroComplementar ? ` (${this.props.parte.registroComplementar})` : ''}
                        `}
                        {this.props.parte.procuradoria?.nome && ProcessoStore.mostraIconeCustosLegis && (
                            <Tooltip title={this.props.parte.procuradoria.nome}>
                                <Apartment />
                            </Tooltip>
                        )}
                    </div>

                    <div className="lista-align-left">
                        <TableRepresentante parteRepresentante={this.props.parte.representantes} />
                    </div>
                </div>
            </div>
        );
    }

};

export default TableParte;

